// src/utils/fileValidation.js

export const validateImageFile = (
    file,
    type = "default"
) => {

    return new Promise((resolve, reject) => {

        if (!file) {
            return reject("File is required.");
        }

        // Common allowed types
        const allowedTypes = [
            "image/png",
            "image/jpeg",
            "image/jpg"
        ];

        // Default validation config
        let validation = {
            minSize: 15 * 1024, // 15 KB
            maxSize: 30 * 1024, // 30 KB
            width: 300,
            height: 100,
        };

        // Blog validation config
        if (type === "blog") {
            validation = {
                minSize: 10 * 1024,  // 10 KB
                maxSize: 100 * 1024, // 100 KB
                width: 1200,
                height: 630,
            };
        }

        // Validate file type
        if (!allowedTypes.includes(file.type)) {
            return reject("Only PNG, JPG or JPEG files are allowed.");
        }

        // Validate file size
        if (
            file.size < validation.minSize ||
            file.size > validation.maxSize
        ) {
            return reject(
                `File size must be between ${validation.minSize / 1024}KB and ${validation.maxSize / 1024}KB.`
            );
        }

        // Validate image dimensions
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.src = objectUrl;

        img.onload = () => {

            if (
                img.width !== validation.width ||
                img.height !== validation.height
            ) {
                URL.revokeObjectURL(objectUrl);

                return reject(
                    `Image dimensions must be ${validation.width}x${validation.height} pixels.`
                );
            }

            URL.revokeObjectURL(objectUrl);
            return resolve("Valid");
        };

        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            return reject("Invalid image file.");
        };

    });
};